import Table from 'components/Table';
import React, { useCallback, useEffect, useState } from 'react';
import Dashboard from './components/Dashboard';
import { useSelector } from 'react-redux';
import api from 'services/api';
import { formatValueInBrazilianCurrency } from 'utils';

function ReportFinance() {
  const { nameProperty } = useSelector((state) => state.nameProperty);
  const [dateRange, setDateRange] = useState(null);
  const [openProgress, setOpenProgress] = useState(false);
  const [items, setItems] = useState([]);
  const [totals, setTotals] = useState({ expenses: 0, income: 0, profit: 0 });

  const columns = [
    {
      title: 'Código',
      field: 'cod',
      type: 'string',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Centro de Custo',
      field: 'description',
      type: 'string',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Valor',
      field: 'value',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => formatValueInBrazilianCurrency(rowData.value),
    },
    {
      title: 'Percentual',
      field: 'percent',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => `${rowData.percent.toFixed(2)?.replace('.', ',')}%`,
    },
  ];

  const loadReportFinance = useCallback(async () => {
    try {
      setOpenProgress(false);
      const response = await api.get('/accounts-center/report', {
        params: {
          'begin-date': dateRange?.[0],
          'end-date': dateRange?.[1],
        },
      });
      if (response.data.length === 0) {
        setOpenProgress(true);
      }
      if (response.data) {
        const {
          items: payload, expenses, income, profit,
        } = response.data;
        setItems(payload);
        setTotals({ expenses, income, profit });
      }
    } catch (err) {
      throw new Error(err);
    } finally {
      setOpenProgress(true);
    }
  }, [dateRange]);

  useEffect(() => {
    loadReportFinance();
  }, [loadReportFinance, nameProperty]);

  return (
    <Dashboard
      dateRange={dateRange}
      setDateRange={setDateRange}
      title="Relatório Financeiro"
      totals={totals}
      loading={!openProgress}
    >
      <Table
        isVisible={false}
        title="Relatório Financeiro"
        titleCustomized=" "
        route="/"
        routeAdd="/"
        columns={columns}
        columnsForExport={columns}
        exportData={items}
        data={items}
        dataLoaded={openProgress}
        copy={false}
        blockClick
      />
    </Dashboard>
  );
}

export default ReportFinance;
